import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import Product from "./components/Product";
import NotFoundRoute from "./components/NotFoundRoute";

import "./App.css";
const App = () => (
  <BrowserRouter>
    <Routes>
      <Route path="/" element={<Navigate to="/products" replace />} />
      <Route path="/products" element={<Product />} />
      <Route path="/not-found" element={<NotFoundRoute />} />
      <Route path="*" element={<Navigate to="/not-found" replace />} />
    </Routes>
  </BrowserRouter>
);

export default App;


